import BaseAuth from "./BaseAuth";
import Passkey from "./passkey";

class Validate extends BaseAuth {
    constructor(root, settings) {
        super(root, settings);
        this.root = root;
        this.settings = settings;
        this.passkey = new Passkey(this.root, this.settings);
    }

    init() {
        this.passkey.init();
        //Validate button
        const validateButton = document.getElementById('rsssl-passkey-button');
        if (validateButton) {
            validateButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.passkey.handlePasskeyLogin(event);
            });
        }
    }
}

export default Validate;